<div class="table-container left-margin">
    <ng-container *ngIf=" !(isPartOfArNavigation$  | async)">
        <div class="alert alert-danger">{{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}</div>
    </ng-container>
    <ng-container *ngIf="(isPartOfArNavigation$ | async)" content [ngSwitch]="dataState">
        <div *ngSwitchCase="'loading'">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
        <aumico-annualReport-appropriation-of-profit-page
            *ngSwitchCase="'success'"
            [stylePreferenceOptions]="stylePreferenceOptions"
            (appropriationOfProfitOutput)="onAppropriationOfProfitChange($event)"
            (appropriationOfProfitPrefilledValueOutput)="onAppropriationOfProfitPrefilledValueOutputprepared($event)"
            [balanceAccounts]="mappedBalanceAccounts"
            [equityAccounts]="equityAccounts"
            [previousCcr]="previousCcr"
            [previousShowCcrTable]="previousShowCcrTable"
            [balanceTemplate]="balanceTemplate"
            [currentAnnualProfit]="currentAnnualProfit"
            [previousAnnualProfit]="previousAnnualProfit"
            [currentYearDate]="currentYearDate"
            [previousYearDate]="previousYearDate"
            [currency]="currentAnnualReport.generalInformation.currency.name"
            [appropriationData]="getAppropriationData()"
            [numberFormat]="numberFormat"
            [removeEmptyLines]="removeEmptyLines"
            [selectedAccount]="selectedAccount"
            [previousAnnualProfit]="previousAnnualProfit"
            [previousProfitCalculation]="previousProfitCalculation"
            [previousProposal]="previousProposal"
            [hasNoPreviousData]="hasNoPreviousData"
            [reportLocale]="currentAnnualReport.locale"
            [previousAopDescription]="aopDescription"
            [isSavedBefore]="isSavedBefore"
        >
        </aumico-annualReport-appropriation-of-profit-page>

        <div *ngSwitchCase="'error'" class="alert alert-danger">
            {{ 'aumico_reports_required_data_not_completed' | i18next }}
        </div>
        <div *ngSwitchDefault class="alert alert-danger">UNKNOWN STATE</div>
    </ng-container>
    <div>
        <ng-template #footerTemplate>
            <aum-action-bar-pure
                [extraActionButtons]="footerExtraButtonActions"
                nextButtonPrefixText="{{ nextStepPrefix | i18next }}"
                nextButtonText="{{ nextStepLabel | i18next }}"
                [nextButtonAction]="proceedButtonClicked"
                nextButtonRouterLink="../{{ nextStepPath }}"
                [nextButtonDisabled]="disableProceedButton"
                backButtonPrefixText="{{ previousStepPrefix | i18next }}"
                backButtonText="{{ previousStepLabel | i18next }}"
                backButtonRouterLink="../{{ previousStepPath }}"
                [backButtonIcon]="previousStepIcon"
            ></aum-action-bar-pure>
        </ng-template>
    </div>
</div>
